import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import AuthContainer from '@shared/hooks/state/AuthContainer';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useEffect, useState } from 'react';

export function useAdminInitializeData() {
    const [isLoading, setIsLoading] = useState(true);
    const authContainer = AuthContainer.useContainer();
    const currentUserContainer = CurrentUserContainer.useContainer();
    const organizationContainer = OrganizationContainer.useContainer();
    const alertContainer = AlertsContainer.useContainer();

    useEffect(() => {
        const initialize = async () => {
            try {
                await currentUserContainer.loadCurrentUser();
                await currentUserContainer.loadUserLicenseAccess();
                await organizationContainer.initializeFromRemote();
            } catch (error) {
                alertContainer.showError('Error initializing data');
            } finally {
                setIsLoading(false);
            }
        };

        if (currentUserContainer.currentUser === null && authContainer.isAuthenticated === true) {
            initialize();
        }
    }, [currentUserContainer.currentUser, authContainer.isAuthenticated]);

    useEffect(() => {
        if (authContainer.isAuthenticated && currentUserContainer.currentUser && !organizationContainer.loading) {
            setIsLoading(false);
        }
    }, [authContainer.isAuthenticated, currentUserContainer.currentUser, organizationContainer.loading]);

    return { isLoading };
}
